import { getWorkspaceFrameStyles } from '@components/v2/constants';
import type { SidebarState } from '@components/v2/layout/AppTemplate/appTemplate.types';
import { makeStyles } from 'tss-react/mui';

export const PRODUCT_DETAILS_PANEL_FRAME_PADDING = 1;

interface StyleParams {
  sidebarState: SidebarState;
}

export const useProductDetailsPanelStyles = makeStyles<StyleParams>()((theme, { sidebarState }) => {
  const FRAME_PADDING = theme.spacing(PRODUCT_DETAILS_PANEL_FRAME_PADDING);
  const SIDEBAR_FRAME_GAP = sidebarState === 'collapsed' ? 0 : theme.spacing(0.25);
  const leftInset = sidebarState === 'hidden' ? FRAME_PADDING : SIDEBAR_FRAME_GAP;

  return {
    panel: {
      ...getWorkspaceFrameStyles(theme),
      position: 'absolute',
      zIndex: 1,
      top: 0,
      bottom: 0,
      left: leftInset,
      right: FRAME_PADDING,
      display: 'flex',
      flexDirection: 'column',
      minWidth: 0,
      overflow: 'hidden',
      [theme.breakpoints.down('sm')]: {
        left: 0,
        right: 0,
      },
    },
  };
});
